module.exports = __webpack_public_path__ + "img/hdjy_l.0aff72cb.png";